<template>
  <div class="modern-layout d-flex fill-height cassie-application-background">
    <!-- Navigation bar -->
    <ModernNavBar
      :links="links"
      :change-show-filters="changeShowFilters"
      :reset-admin-portal-filters="resetAdminPortalFilters"
      class="flex-grow-0 flex-shrink-0"
    />

    <!-- Loading overlay -->
    <v-overlay
      z-index="999"
      :value="showSpinner"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <!-- Main content slot -->
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import type { PropType } from 'vue';
import ModernNavBar from './ModernNavBar.vue';
import type { NavLink } from './types';

export default Vue.extend({
  name: 'ModernLayout',
  components: {
    ModernNavBar
  },
  props: {
    links: {
      type: Array as PropType<NavLink[]>,
      default: () => []
    },
    showSpinner: {
      type: Boolean,
      default: false
    },
    changeShowFilters: {
      type: Function as PropType<(show: boolean) => void>,
      default: () => {}
    },
    resetAdminPortalFilters: {
      type: Function as PropType<() => void>,
      default: () => {}
    }
  }
});
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
